/**
 * Секрет браузера, который регистрировал.
 *
 * Человек заполняет форму на одном устройстве, а письмо открывает на другом:
 * cookie достаётся тому, где нажата ссылка. По этому секрету браузер, который
 * ждал, спрашивает сервер, не подтвердили ли адрес, и получает свою сессию.
 *
 * Хранится в localStorage, а не в пространстве пользователя: пространство
 * выгружается кнопкой «Скачать мой прогресс», и секрету в выгрузке не место.
 * Он живёт до подтверждения и удаляется сразу, как только сессия открыта.
 */

const STORAGE_KEY = 'type2x.registration-claim';

/** Запоминает секрет. Недоступное хранилище означает лишь вход паролем. */
export function rememberRegistrationClaim(token: string): void {
  try {
    globalThis.localStorage.setItem(STORAGE_KEY, token);
  } catch {
    // Хранилища нет — подтверждение придётся забрать входом по паролю.
  }
}

/** Возвращает сохранённый секрет либо `null`. */
export function readRegistrationClaim(): string | null {
  try {
    const stored = globalThis.localStorage.getItem(STORAGE_KEY);
    return stored === null || stored === '' ? null : stored;
  } catch {
    return null;
  }
}

/** Забывает секрет: он сработал или больше не нужен. */
export function forgetRegistrationClaim(): void {
  try {
    globalThis.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Забывать нечего.
  }
}
